import { BackendQueryKeys, useTypeSafeQuery } from '@oresundsbron/api';
import { PhoneCode } from '@oresundsbron/validators';
import { sortBy } from 'fp-ts/lib/Array';
import { identity, pipe } from 'fp-ts/lib/function';
import { fromNullable, match } from 'fp-ts/lib/Option';
import { useMemo } from 'react';
import { byCountryLocale, byPromotedCountries, byString } from '../lib/sort';
import { useRouter } from 'next/router';

type PhoneCodeItem = {
  key: string;
  countryName: string;
  value: string;
  country: string;
};

const sort = (locale: string) =>
  sortBy([
    byPromotedCountries<PhoneCodeItem>((item) => item.country),
    byCountryLocale<PhoneCodeItem>((item) => item.country)(locale),
    byString<PhoneCodeItem>((item) => item.countryName),
  ]);

export function usePhoneCodes() {
  const { locale } = useRouter();
  const { data } = useTypeSafeQuery(
    BackendQueryKeys.PhoneCodeList({ locale }),
    (req) => req.Phone.phoneCodeList(locale || '')
  );

  return useMemo(
    () =>
      pipe(
        data,
        fromNullable,
        match(() => [] as PhoneCode[], identity),
        sort(locale || '')
      ),
    [data, locale]
  );
}
